import isEmpty from 'lodash/isEmpty';

class ApiFieldset {

    constructor(fieldsetData = null) {
        this.clearFields();
        this.clearRelations();

        if (fieldsetData !== null && typeof fieldsetData === "object") {
            if (fieldsetData.hasOwnProperty('fields')) {
                this.fields = fieldsetData.fields;
            }
            
            if (fieldsetData.hasOwnProperty('relations')) {
                this.relations = fieldsetData.relations;
            }
        }
    }

    /**
     * @returns {boolean}
     */
    get isValid() {
        return !isEmpty(this.fields) ||
            !isEmpty(this.relations);
    }

    /**
     * @returns {string}
     */
    get fields() {
        return this._fields;
    }

    /**
     * @param value
     */
    set fields(value) {
        if (!Array.isArray(value)) {
            return;
        }
        this._fields = value;
    }

    /**
     * @returns {{}|*}
     */
    get relations() {
        return this._relations;
    }

    /**
     * @param relationValues
     */
    set relations(relationValues) {
        this.clearRelations();
        if (typeof relationValues !== 'object') {
            return;
        }
        
        let relationValue;
        for (let relationName in relationValues) {
            if (!relationValues.hasOwnProperty(relationName)) {
                continue;
            }
            relationValue = relationValues[relationName];
            this.addRelation(relationName, relationValue);
        }
    }

    /**
     * @returns {boolean}
     */
    hasData() {
        return !isEmpty(this.fields) ||
            !isEmpty(this.relations);
    }

    /**
     * @returns {{andOr: string, params: {}|*, relations: {}|*}}
     */
    toObject() {
        const data = {};
        
        if (!isEmpty(this.fields)) {
            data['fields'] = this.fields;
        }

        if (!isEmpty(this.relations)) {
            data['relations'] = {};
            for (let relation in this.relations) {
                if (!this.relations.hasOwnProperty(relation)) {
                    continue;
                }
                data['relations'][relation] = this.relations[relation].toObject();
            }
        }

        return data;
    }

    /**
     * @returns {string}
     */
    toJson() {
        return JSON.stringify(this.toObject());
    }

    /**
     * @returns {ApiFieldset}
     */
    clearFields() {
        this._fields = [];
        return this;
    }

    /**
     * @param fieldName
     * @returns {ApiFieldset}
     */
    addField(fieldName) {
        if (fieldName === undefined) {
            return this;
        }
        
        this._fields.push(fieldName);
        return this;
    }

    /**
     * @param fieldName
     * @returns {ApiFieldset}
     */
    forgetField(fieldName) {
        if (fieldName === undefined) {
            return this;
        }
        
        const index = this._fields.indexOf(fieldName);
        if (index > -1) {
            this._fields.splice(index, 1);
        }
        
        return this;
    }

    /**
     * @returns {ApiFieldset}
     */
    clearRelations() {
        this._relations = {};
        return this;
    }

    /**
     * @param relationName
     * @param apiFieldset
     * @returns {ApiFieldset}
     */
    addRelation(relationName, apiFieldset) {
        if (
            relationName === undefined ||
            apiFieldset === undefined ||
            !(apiFieldset instanceof ApiFieldset)
        ) {
            return this;
        }
        
        this._relations[relationName] = apiFieldset;
        return this;
    }

    /**
     * @param relationName
     * @returns {ApiFieldset}
     */
    forgetRelation(relationName) {
        if (relationName === undefined) {
            return this;
        }
        
        delete this._relations[relationName];
        return this;
    }
}

export default ApiFieldset;
